import { SBP_PAY_TEST_STATUSES } from 'modules/organizer/domain/constants/wallet-topup';
import { WalletTopupStatus } from 'modules/organizer/domain/interfaces/wallet-topup';
import * as yup from 'yup';

export interface SbpPayTestStatusOption {
  label: string;
  value: WalletTopupStatus;
}

export interface SbpPayTestFormValues {
  status: SbpPayTestStatusOption;
}

export const sbpPayTestFormValidator = yup.object({
  status: yup
    .object({
      value: yup.string().oneOf([...SBP_PAY_TEST_STATUSES], 'Выберите статус').required('Выберите статус'),
      label: yup.string().required(),
    })
    .required('Выберите статус'),
});
